@if (canDeleteContract) {
  <button
    mat-icon-button
    (click)="deleteContract()"
    matTooltip="Supprimer le contrat"
    aria-label="Supprimer le contrat"
  >
    <mat-icon class="error">delete</mat-icon>
  </button>
}
